import { useLayoutEffect, useRef, useState } from 'react'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { useReducedMotion } from '../hooks/useReducedMotion'

gsap.registerPlugin(ScrollTrigger)

const steps = [
  { number: '01', title: 'DIRECTION', copy: 'Your goals, audience and strongest angle become one clear brief.' },
  { number: '02', title: 'DESIGN', copy: 'A distinctive visual system, shaped around your real business.' },
  { number: '03', title: 'BUILD', copy: 'Responsive code, purposeful motion and every key interaction.' },
  { number: '04', title: 'LAUNCH', copy: 'Final checks, clean handoff and a website ready to do its job.' },
]

export function ProcessDial() {
  const section = useRef<HTMLElement>(null)
  const dial = useRef<HTMLDivElement>(null)
  const [active, setActive] = useState(0)
  const reduced = useReducedMotion()

  useLayoutEffect(() => {
    if (reduced || !section.current || !dial.current) return
    const context = gsap.context(() => {
      gsap.to(dial.current, {
        rotate: 270,
        ease: 'none',
        scrollTrigger: {
          trigger: section.current,
          start: 'top 75%',
          end: 'bottom 30%',
          scrub: 0.7,
          onUpdate: ({ progress }) => setActive(Math.min(3, Math.floor(progress * 4))),
        },
      })
      gsap.to('.dial-center', {
        rotate: -270,
        ease: 'none',
        scrollTrigger: {
          trigger: section.current,
          start: 'top 75%',
          end: 'bottom 30%',
          scrub: 0.7,
        },
      })
    }, section)
    return () => context.revert()
  }, [reduced])

  return (
    <section className="process-section" id="process" ref={section}>
      <div className="process-copy">
        <p className="eyebrow eyebrow--light">02 / THE PROCESS</p>
        <h2>FROM FIRST FRAME<br /><em>TO LAUNCH.</em></h2>
        <p>A clear process. No mystery.</p>
        <div className="process-detail" aria-live="polite">
          <strong>{steps[active].number} / {steps[active].title}</strong>
          <span>{steps[active].copy}</span>
        </div>
      </div>
      <div className="process-dial-wrap">
        <div className="process-dial" ref={dial} aria-hidden="true">
          <div className="dial-center"><span>Q1</span><small>METHOD</small></div>
          {steps.map((step, index) => (
            <div className={`dial-step dial-step--${index + 1}`} key={step.number}>
              <span>{step.number}</span><strong>{step.title}</strong>
            </div>
          ))}
          <div className="dial-notch dial-notch--1" /><div className="dial-notch dial-notch--2" />
          <div className="dial-notch dial-notch--3" /><div className="dial-notch dial-notch--4" />
        </div>
        <div className="dial-cursor" aria-hidden="true" />
      </div>
    </section>
  )
}
